import React, { Component } from "react";
import Steps from "./steps";
import {
  and,
  find,
  gt,
  gte,
  isEmpty,
  isNil,
  lte,
  map,
  or,
  propEq,
  equals
} from "ramda";
import { currentLocale } from "../locale";
import Sticky from "react-stickynode";
import NavButtons from "./navButtons";
import "../style/sign.scss";

class Stepper extends Component {
  componentDidMount() {
    this.timer();
  }

  ///noneSelected reducer causes Next button flash => turns selected: true
  ///nextConfused reducer for the AboutSigner toast => turn selected: undefined
  ///nextSelected reducer sets selected back to false.
  componentDidUpdate(prevProps, prevState) {
    if (this.props.currentStep !== prevProps.currentStep) {
      this.props.nextSelected();
      this.timer();
    } else if (
      and(
        !equals(this.props.validStep, prevProps.validStep),
        equals(true, this.props.validStep)
      )
    ) {
      setTimeout(this.timer2, 10000, this.props.currentStep);
    } else if (
      and(
        !equals(this.props.recording, prevProps.recording),
        gt(this.props.recording.duration, 0)
      )
    ) {
      setTimeout(this.timerStep7, 10000, this.props.currentStep);
    }
    return;
  }

  //this is for form pages => if valid then 10s timer before flashing
  timer2 = value => {
    if (
      and(
        and(
          equals(this.props.currentStep, value),
          !equals(7, this.props.currentStep)
        ),
        this.props.validStep
      )
    ) {
      this.props.noneSelected();
    }
    clearTimeout(this.timer2);
  };

  //successful video recording
  timerStep7 = value => {
    if (
      and(equals(this.props.currentStep, value), !isEmpty(this.props.recording))
    ) {
      this.props.noneSelected();
    }
  };

  ///Timer and handleConfused are for non-form pages
  timer = () => {
    if (this.props.currentStep === 2) {
      setTimeout(this.handleConfused, 15000, this.props.currentStep);
    } else if (and(equals(0, this.props.currentStep), this.props.validStep)) {
      setTimeout(this.handleInitialConfused, 15000, this.props.currentStep);
    } else if (
      or(
        and(gte(this.props.currentStep, 4), lte(this.props.currentStep, 6)),
        equals(8, this.props.currentStep)
      )
    ) {
      setTimeout(this.handleConfused, 120000, this.props.currentStep);
    } else if (and(this.props.currentStep === 9, this.props.validStep)) {
      setTimeout(this.handleConfused, 15000, this.props.currentStep);
    }
    return clearTimeout(this.timer);
  };

  //first page
  handleInitialConfused = value => {
    if (equals(0, this.props.currentStep, value)) {
      this.props.noneSelected();
    }
  };

  handleConfused = value => {
    if (
      //This is for the step2 Toast - Banner
      (and(equals(2, this.props.currentStep, value)),
      equals(false, this.props.validStep))
    ) {
      this.props.nextConfused();
    } else if (
      //(steps = 4-6 || 8) && value === currentStep
      and(
        or(
          and(gte(this.props.currentStep, 4), lte(this.props.currentStep, 6)),
          equals(8, this.props.currentStep)
        ),
        and(equals(this.props.currentStep, value), this.props.validStep)
      )
    ) {
      this.props.noneSelected();
    } else if (
      equals(9, this.props.currentStep, value) &&
      !isNil(this.props.formikProps.touched.signature)
    ) {
      this.props.noneSelected();
    }
    clearTimeout(this.timer);
  };

  render() {
    const {
      steps,
      currentStep,
      activeStep,
      waiver,
      validStep,
      isValid,
      validBackStep,
      recording,
      requesting,
      loading,
      flashing
    } = this.props;

    const step1 = find(propEq("step", 1))(steps);
    const step4 = find(propEq("step", 4))(steps);
    const step6 = find(propEq("step", 6))(steps);
    const optionalSteps = [step1, step4, step6];
    const optionalSteps14 = [step1, step4];
    const optionalSteps16 = [step1, step6];
    const optionalSteps46 = [step4, step6];
    let stepsOptions;
    if (
      this.props.waiver.contactInformation === false &&
      this.props.waiver.videoUrl === null &&
      (this.props.waiver.participantPdf === null ||
        this.props.waiver.guardianPdf === null)
    ) {
      stepsOptions = steps.filter(step => !optionalSteps.includes(step));
    } else if (
      this.props.waiver.contactInformation === false &&
      this.props.waiver.videoUrl === null
    ) {
      stepsOptions = steps.filter(step => !optionalSteps14.includes(step));
    } else if (
      this.props.waiver.contactInformation === false &&
      (this.props.waiver.participantPdf === null ||
        this.props.waiver.guardianPdf === null)
    ) {
      stepsOptions = steps.filter(step => !optionalSteps16.includes(step));
    } else if (
      this.props.waiver.videoUrl === null &&
      (this.props.waiver.participantPdf === null ||
        this.props.waiver.guardianPdf === null)
    ) {
      stepsOptions = steps.filter(step => !optionalSteps46.includes(step));
    } else if (this.props.waiver.videoUrl === null) {
      stepsOptions = steps.filter(step => step !== step4);
    } else if (this.props.waiver.contactInformation === false) {
      stepsOptions = steps.filter(step => step !== step1);
    } else if (
      this.props.waiver.participantPdf === null ||
      this.props.waiver.guardianPdf === null
    ) {
      stepsOptions = steps.filter(step => step !== step6);
    } else {
      stepsOptions = steps;
    }

    let moveForward;
    if (activeStep.step === this.props.steps.length - 1) {
      moveForward = this.props.formikProps.handleSubmit;
    } else if (
      activeStep.step === 0 &&
      this.props.waiver.contactInformation === false &&
      this.props.waiver.iceNumber === false
    ) {
      moveForward = this.props.skipForward;
    } else if (activeStep.step === 1) {
      moveForward = this.props.stepForward;
    } else if (activeStep.step === 2) {
      moveForward = this.props.onRoleChange && this.props.stepForward;
    } else if (activeStep.step === 3 && this.props.waiver.videoUrl === null) {
      moveForward = this.props.skipForward;
    } else if (
      activeStep.step === 5 &&
      (this.props.waiver.participantPdf === null ||
        this.props.waiver.guardianPdf === null)
    ) {
      moveForward = this.props.skipForward;
    } else if (
      activeStep.step === 5 &&
      this.props.signingInfo.role === 3 &&
      (this.props.waiver.participantPdf === null ||
        this.props.waiver.guardianPdf === null)
    ) {
      moveForward = this.props.skipForward;
    } else if (activeStep.step === 5 && this.props.signingInfo.role !== 3) {
      moveForward = this.props.skipForward;
    } else {
      moveForward = this.props.stepForward;
    }
    let moveBack;
    if (
      activeStep.step === 2 &&
      this.props.waiver.contactInformation === false &&
      this.props.waiver.iceNumber === false
    ) {
      moveBack = this.props.skipBack;
    } else if (activeStep.step === 5 && this.props.waiver.videoUrl === null) {
      moveBack = this.props.skipBack;
    } else if (
      activeStep.step === 7 &&
      (this.props.waiver.participantPdf === null ||
        this.props.waiver.guardianPdf === null)
    ) {
      moveBack = this.props.skipBack;
    } else if (activeStep.step === 7 && this.props.signingInfo.role !== 3) {
      moveBack = this.props.skipBack;
    } else if (
      activeStep.step === 7 &&
      this.props.signingInfo.role === 3 &&
      (this.props.waiver.participantPdf === null ||
        this.props.waiver.guardianPdf === null)
    ) {
      moveBack = this.props.skipBack;
    } else {
      moveBack = this.props.stepPrevious;
    }
    let nextButton;
    if (activeStep.step === this.props.steps.length - 1) {
      nextButton = currentLocale.submit;
    } else {
      nextButton = currentLocale.next;
    }
    let innerZ;
    if (this.props.noSticky) {
      innerZ = "0%";
      // } else if (activeStep.step === 7 || activeStep.step === 8) {
      //   innerZ = 1000
    } else {
      //  innerZ = '100%'
      innerZ = 1000;
    }
    return (
      <div className="stepper-container steps is-small" id="stepsDemo">
        {map(
          step => (
            <Steps
              hidden={step.step === 6 && this.props.signingInfo.role !== 3}
              title={step.title}
              step={step.step}
              currentStep={currentStep}
              key={step.step}
              //  id={step.step}
              waiver={waiver}
              id="stepper"
            />
          ),
          stepsOptions
        )}
        <br />

        <Sticky
          className="titleBar"
          top="#stepper"
          innerZ={innerZ}
          bottomBoundry={0}
        >
          <NavButtons
            backDisabled={
              currentStep === 0 ||
              validBackStep === false ||
              (currentStep === 7 && requesting === true) ||
              (currentStep === 7 && recording.status === 4)
            }
            backOnClick={moveBack}
            loading={loading}
            flashing={flashing}
            forwardDisabled={
              validStep === false ||
              isValid === false ||
              (currentStep === 7 && requesting === true) ||
              (currentStep === 7 && recording.status !== 6) ||
              loading
            }
            flashForward={equals(false, this.props.selected)}
            forwardOnClick={moveForward}
            nextButton={nextButton}
          />
        </Sticky>
      </div>
    );
  }
}

export default Stepper;
